export const config = {
  title: "Derrick Freeman | Keller Williams Realty | Buford, GA",
  meta: {
    description:
      "Derrick Freeman is your trusted real estate professional with Keller Williams Realty Atl. Partners in Buford, GA. Expert guidance for buying, selling, and investing in homes throughout Gwinnett County and Metro Atlanta.",
    keywords: [
      "Derrick Freeman Realtor",
      "Keller Williams Buford",
      "Real Estate Buford GA",
      "Homes for Sale Buford",
      "Gwinnett County Real Estate",
      "Buy Home Buford GA",
      "Sell Home Buford GA",
      "Real Estate Agent Buford"
    ],
    author: "Derrick Freeman",
    canonicalUrl: "https://www.derrickfreemanrealty.com/",
  },
  sections: {
    header: {
      businessName: "Derrick Freeman",
      tagline: "Keller Williams Realty Atl. Partners",
    },
    sectionB: {
      heroTitle: "Your Trusted Real Estate Partner in Buford",
      heroSubtitle: "Expert Real Estate Services Throughout Metro Atlanta & Gwinnett County",
      learnAboutText: "Schedule a Consultation",
      phoneNumber: "6782968072",
      phoneLabel: "(678) 296-8072",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&q=80",
      cardData: [
        {
          title: "Buyer Representation",
          description:
            "Find your dream home with expert guidance through every step of the buying process.",
        },
        {
          title: "Seller Services",
          description:
            "Maximize your home's value with strategic marketing and professional representation.",
        },
        {
          title: "Market Analysis",
          description:
            "Get accurate property valuations and insights into the local real estate market.",
        },
      ],
      description:
        "With Keller Williams Realty Atl. Partners, Derrick Freeman provides personalized real estate services in Buford, Sugar Hill, Suwanee, and throughout Metro Atlanta. Whether you're buying your first home or selling your property, experience counts.",
    },
    sectionC: {
      servicesTitle: "Real Estate Services",
      servicesDescription:
        "Comprehensive real estate solutions tailored to your unique needs and goals. From first-time buyers to seasoned investors, I'm here to guide you every step of the way.",
      cards: [
        {
          title: "Home Buying",
          description:
            "Expert guidance through the entire home buying process, from search to closing. Access exclusive listings and get the best deal possible.",
          imageSrc: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80",
          imageAlt: "Beautiful home exterior",
        },
        {
          title: "Home Selling",
          description:
            "Strategic marketing, professional photography, and expert negotiation to sell your home quickly and for top dollar.",
          imageSrc: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=600&q=80",
          imageAlt: "For sale sign in front of home",
        },
        {
          title: "Investment Properties",
          description:
            "Build wealth through real estate with expert advice on investment opportunities, rental properties, and market trends.",
          imageSrc: "https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?w=600&q=80",
          imageAlt: "Modern residential development",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "First-Time Homebuyer Programs",
        "Luxury Home Marketing",
        "Property Valuation & CMA",
        "Relocation Services",
        "New Construction Representation",
        "Short Sale & Foreclosure Assistance",
      ],
    },
    sectionD: {
      aboutTitle: "About Derrick Freeman",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/87/2405887_normal.jpg",
        alt: "Professional real estate agent",
      },
      aboutText: [
        "Derrick Freeman is a dedicated real estate professional with Keller Williams Realty Atl. Partners, serving Buford, Gwinnett County, and the greater Metro Atlanta area. With a commitment to excellence and a client-first approach, Derrick helps buyers and sellers navigate one of life's most important decisions.",
        "As part of the Keller Williams network, Derrick combines local market expertise with innovative technology and world-class training to deliver exceptional results. Whether you're buying your first home, upgrading to your dream property, or selling for top dollar, Derrick provides the knowledge, dedication, and personalized service you deserve.",
        "Contact Derrick today to discuss your real estate goals and discover how his expertise can help you achieve them.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Derrick Freeman - Keller Williams Realtor",
      businessName: "Derrick Freeman",
      subtitle: "Keller Williams Realty Atl. Partners",
      contact: {
        phone: "6782968072",
        phoneLabel: "(678) 296-8072",
        email: "derrickfreeman@kw.com",
        website: "https://www.derrickfreemanrealty.com/",
        address: "4878 Manhattan Dr, Buford, GA 30518",
      },
      socialMedia: {
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: "",
      },
    },
    sectionF: {
      address: "4878 Manhattan Dr, Buford, GA 30518",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.8254!2d-83.9776!3d34.1330!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a1a5b1d9c7b1%3A0x1234567890abcdef!2s4878%20Manhattan%20Dr%2C%20Buford%2C%20GA%2030518!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;